import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { UncontrolledTooltip } from 'reactstrap';

import moment from 'moment';
import randomstring from 'randomstring';
import { dateFormat } from '../../util/date';

class Chrono extends Component {
    constructor(props) {
        super(props);

        this.state = {
            duration: null,
            isOver: false,
        };

        this.durationInterval = null;
        this.id = randomstring.generate();
    }

    componentDidMount() {
        this.setDuration();
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.state.duration) {
            this.setDuration();
        } else if(this.state.duration && !this.durationInterval) {
            this.durationInterval = setInterval(this.setDuration, 1000);
        }
        if(!prevState.isOver && this.state.isOver) {
            this.endChrono();
        }
    }

    componentWillUnmount() {
        clearInterval(this.durationInterval);
    }

    getThresholdClassName() {
        if(this.state.isOver || (this.props.threshold && moment.utc().isSameOrAfter(this.props.threshold))) {
            return 'text-danger';
        }
        return '';
    }

    setDuration = () => {
        if(this.props.date && !this.state.isOver) {
            this.setState({
                duration: moment.duration(moment(this.props.date).diff(moment.utc())),
                isOver: moment.utc().isAfter(this.props.date),
            });
        }
    };

    endChrono = () => {
        console.log('Chrono::: End');
        setTimeout(() => {
            this.setState({
                isOver: true,
            }, () => {
                this.props.onEnd && this.props.onEnd();
                clearInterval(this.durationInterval);
            });
        }, 1000);
    };

    render() {
        if(this.state.duration) {
            let days = this.state.duration.days();
            let hours = this.state.duration.hours();
            let minutes = this.state.duration.minutes();
            let seconds = this.state.duration.seconds();

            if(days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
                if(!this.props.allowNegative) {
                    days = 0;
                    hours = 0;
                    minutes = 0;
                    seconds = 0;
                    if(this.props.hideOnEnd) {
                        return null;
                    }
                }
            }
            // if(!this.props.allowNegative && (days < 0 || hours < 0 || minutes < 0 || seconds < 0)) {
            //     return null;
            // }

            days = `${days}`.length < 2 ? `0${days}` : days;
            hours = `${hours}`.length < 2 ? `0${hours}` : hours;
            minutes = `${minutes}`.length < 2 ? `0${minutes}` : minutes;
            seconds = `${seconds}`.length < 2 ? `0${seconds}` : seconds;

            return (
                <Fragment>
                    <span id={`chrono-${this.id}`} className={`${this.getThresholdClassName()}`}>
                        {`${days !== '00' ? `${days}:` : ''}${hours !== '00' ? `${hours}:` : ''}${minutes}:${seconds}`}
                    </span>
                    <UncontrolledTooltip target={`chrono-${this.id}`}>
                        {days !== '00' && <span>{days}<FormattedMessage id="days" defaultMessage="day(s)" />{' '}</span>}
                        {hours !== '00' && <span>{hours}<FormattedMessage id="hours" defaultMessage="hour(s)" />{' '}</span>}
                        <span>{minutes}<FormattedMessage id="minutes" defaultMessage="minute(s)" /></span>
                        {' '}<span>{seconds}<FormattedMessage id="seconds" defaultMessage="second(s)" /></span>
                    </UncontrolledTooltip>
                </Fragment>
            );
        }
        // console.error('Chrono duration', this.props.date, this.state.duration);
        return null;
    }
}

Chrono.defaultProps = {
    onEnd: null,
    allowNegative: false,
    threshold: null,
    hideOnEnd: false,
};

Chrono.propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onEnd: PropTypes.func,
    allowNegative: PropTypes.bool,
    threshold: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    hideOnEnd: PropTypes.bool,
};

export default Chrono;
